import type { OrganisationPlan } from 'app/hooks/useOrganisationFeatures';
import newPlansSegment, { type NewPlansSegment } from 'app/utils/newPlansSegment';

// What the move to the new plans added, by sidebar item id, matching the "Good news" pop-up: Legacy
// customers gained Services (Clinic and Pharmacy First), Orders (EPS) and Patients (patient
// insights); Plus customers gained Managed repeats and segmented broadcasts. Both get What's New,
// which announces it.
const PAGE_IDS: Record<NewPlansSegment, string[]> = {
  'legacy-without-pro': ['announcements', 'services', 'orders', 'patients-component'],
  'plus-without-pro': ['announcements', 'managed-repeats', 'broadcasts'],
};

export default function newlyIncludedPageIds(
  plan: OrganisationPlan | undefined,
  isPro: boolean
): string[] {
  const segment = newPlansSegment(plan, isPro);

  return segment ? PAGE_IDS[segment] : [];
}
